import { useState } from 'react';

function useToggle(value) {
  const [bool, setBool] = useState(value);
  const toggleBool = () => setBool(!bool);
  return [bool, setBool, toggleBool];
}

export default useToggle;
